export const GET_BASE_COLOR = "GET_BASE_COLOR";
export const SET_BASE_COLOR = "SET_BASE_COLOR";
